import React, { useContext, useState } from "react";
import { Button, Container, H4, Span } from "../../Styles/Global.Styled";
import { CartContext } from "../../Context/CartContext";
import { css } from "styled-components";
import AddToCartIcon from "../../Icons/AddToCartIcon";
import LoveIcon from "../../Icons/LoveIcon";
import ProductQuantity from "./ProductQuantity";
import { sizes } from "../../Styles/theme";

const cntStyle = css`
  flex-direction: column;
  align-items: center;
  align-self: flex-start;
  margin-top: 6vh;
  padding: 1vh 2vh 3vh 2vh;
  gap: 3vh;
  border-radius: 25px;
  box-shadow: 0 0 2px 1px grey;
  width: 15vw;
`;
const cntStyleMb = css`
  align-self: center;
  margin-top: 2vh;
  width: 90%;
`;
const cntStyle2 = css`
  justify-content: space-between;
  font-size: 2.5vh;
  width: 100%;
`;
const btnCntainer = css`
  flex-direction: column;
  align-items: center;
  gap: 2vh;
`;
const mainBttn2 = css`
  background-color: ${({ theme }) => theme.main};
  color: white;
  font-size: 1.8vh;
  padding: 0.5vh 3vh;
  border-radius: 12px;
  @media (max-width: ${sizes.tablet}) {
    font-size: 2vh;
  }
`;
const secBttn3 = css`
  border-radius: 25px;
  border: 2px solid ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.main};
  font-size: 1.5vh;
  gap: 0.25vh;
  padding: 0.5vh 5vh;
  @media (max-width: ${sizes.tablet}) {
    font-size: 2vh;
  }
`;
const fontSize3 = css`
  font-size: 2.5vh;
`;
const spanStyle = css`
  color: ${({ theme }) => theme.secColor};
  font-style: italic;
  font-size: 1vh;
  margin-top: 1vh;
`;

const ProductPagePricing = ({ product }) => {
  const { addToCart } = useContext(CartContext);
  const [quantity, setQuantity] = useState(1);
  return (
    <Container $baseStyle={cntStyle} $mStyle={cntStyleMb}>
      <Container $baseStyle={cntStyle2}>
        <H4 $mStyle={fontSize3}>Price</H4>
        <Container>
          <H4 $mStyle={fontSize3}>£{product.price.toFixed(2)}</H4>
          <Span $baseStyle={spanStyle}>per item</Span>
        </Container>
      </Container>
      <ProductQuantity
        product={product}
        localQuantity={quantity}
        setLocalQuantity={setQuantity}
        quantityFrom={"local"}
      />
      <Container $baseStyle={btnCntainer}>
        <Button
          $baseStyle={mainBttn2}
          onClick={() => addToCart(product, quantity)}
        >
          Add to basket
          <AddToCartIcon />
        </Button>
        <Button $baseStyle={secBttn3}>
          Favourite
          <LoveIcon />
        </Button>
      </Container>
    </Container>
  );
};

export default ProductPagePricing;
